"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEntityViewPropertiesDto = instanceOfEntityViewPropertiesDto;
exports.EntityViewPropertiesDtoFromJSON = EntityViewPropertiesDtoFromJSON;
exports.EntityViewPropertiesDtoFromJSONTyped = EntityViewPropertiesDtoFromJSONTyped;
exports.EntityViewPropertiesDtoToJSON = EntityViewPropertiesDtoToJSON;
exports.EntityViewPropertiesDtoToJSONTyped = EntityViewPropertiesDtoToJSONTyped;
const EntityViewSource_1 = require("./EntityViewSource");
/**
 * Check if a given object implements the EntityViewPropertiesDto interface.
 */
function instanceOfEntityViewPropertiesDto(value) {
    if (!('entityId' in value) || value['entityId'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function EntityViewPropertiesDtoFromJSON(json) {
    return EntityViewPropertiesDtoFromJSONTyped(json, false);
}
function EntityViewPropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'entityId': json['entityId'],
        'source': (0, EntityViewSource_1.EntityViewSourceFromJSON)(json['source']),
    };
}
function EntityViewPropertiesDtoToJSON(json) {
    return EntityViewPropertiesDtoToJSONTyped(json, false);
}
function EntityViewPropertiesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'entityId': value['entityId'],
        'source': (0, EntityViewSource_1.EntityViewSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=EntityViewPropertiesDto.js.map